var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.podDetail), function(data, index) {
    return _c('div', [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.documentscanned != 3),
        expression: "data.documentscanned !=3"
      }],
      staticClass: "btn btn-success",
      attrs: {
        "type": "button",
        "title": "Browse POD Images",
        "name": _vm.setname(index, 'browserPod'),
        "id": _vm.setname(index, 'browserPod'),
        "disabled": data.disableBrowseImageButton,
        "value": data.shippingid
      },
      model: {
        value: (_vm.uploadShippingImage1),
        callback: function($$v) {
          _vm.uploadShippingImage1 = $$v
        },
        expression: "uploadShippingImage1"
      }
    }, [_c('i', {
      staticClass: "fa fa-upload",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.openBrowserUploadModal(data, _vm.selectedPodQc[index], _vm.selectedBadRemarks[index], _vm.podBadRemarkComments[index], index)
        }
      }
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.documentscanned != 3),
        expression: "data.documentscanned !=3"
      }],
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "title": "Capture Images using Camera",
        "name": _vm.setname(index, 'scanPodByCamera'),
        "id": _vm.setname(index, 'scanPodByCamera'),
        "disabled": data.disableCameraImageButton
      },
      on: {
        "click": function($event) {
          _vm.openCapturePhotoModal(data, _vm.selectedPodQc[index], _vm.selectedBadRemarks[index], _vm.podBadRemarkComments[index], index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-camera"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.documentscanned != 3),
        expression: "data.documentscanned !=3"
      }],
      staticClass: "btn btn-info",
      attrs: {
        "type": "button",
        "title": "Capture Image Using Scanner",
        "name": _vm.setname(index, 'scanPodByScanner'),
        "id": _vm.setname(index, 'scanPodByScanner'),
        "disabled": data.disableScannerImageButton
      },
      on: {
        "click": function($event) {
          _vm.openScannerModal(data, _vm.selectedPodQc[index], _vm.selectedBadRemarks[index], _vm.podBadRemarkComments[index], index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-barcode"
    })]), _vm._v(" "), _c('button', {
      staticClass: " btn btn-warning",
      attrs: {
        "type": "button",
        "title": "View Captured POD",
        "name": _vm.setname(index, 'viewHubImage'),
        "id": _vm.setname(index, 'viewHubImage')
      },
      on: {
        "click": function($event) {
          _vm.viewPodHubImages(data, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.documentscanned != 3),
        expression: "data.documentscanned !=3"
      }],
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button",
        "name": _vm.setname(index, 'deletepod'),
        "id": _vm.setname(index, 'deletepod'),
        "title": "Delete POD's"
      },
      on: {
        "click": function($event) {
          _vm.OnClickDeletePod(data, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("     \n                                "), _c('button', {
      staticClass: " btn btn-success",
      attrs: {
        "type": "button",
        "disabled": data.uploadedPod.length > 0 ? false : true,
        "title": "Save Captured POD",
        "name": _vm.setname(index, 'viewHubImage'),
        "id": _vm.setname(index, 'viewHubImage')
      },
      on: {
        "click": function($event) {
          _vm.saveReuplodedImage(data, index)
        }
      }
    }, [_vm._v("\n                                  Save\n                                ")])])
  }), _vm._v(" "), (_vm.scanDocumentMdlFlag) ? _c('div', [_c('div', {
    staticClass: "custom-modal show-custom-modal"
  }, [_c('div', {
    staticClass: "custom-modal-content ",
    staticStyle: {
      "height": "83vh",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10",
    staticStyle: {
      "overflow-y": "initial"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "text": "Please Wait ..!!",
      "color": "#FF6700",
      "active": _vm.isGetDeviceLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isGetDeviceLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sticky-row",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('b-input-group', {
    staticClass: "col-lg-6"
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.scannerList,
      "name": "scannerList",
      "id": "scannerList",
      "placeholder": "Select Scanner",
      "label": "label",
      "track-by": "id",
      "scroll": true
    },
    on: {
      "select": function($event) {
        _vm.onChangeScanner($event)
      }
    },
    model: {
      value: (_vm.selectedScanner),
      callback: function($$v) {
        _vm.selectedScanner = $$v
      },
      expression: "selectedScanner"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-refresh btn-success btn-sm",
    staticStyle: {
      "margin-left": "5px",
      "padding": "10px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.onClickScannerRefresh
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "58%",
      "padding-top": "4px",
      "padding-left": "7px"
    }
  }, [_c('span', {
    staticClass: "helpertooltip"
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "helpertooltiptext"
  }, [_vm._v("To install new scanner kindly click on \"Installation Guide\" and follow the process to complete the installation")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://liveb2bxpressclientdoc.s3.ap-south-1.amazonaws.com/b2bcontrolpanel/linux/1.0.0/B2BControlPanelInstallationGuide.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Installation Guide")])])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn-danger btn sm",
    on: {
      "click": _vm.closeScannerModal
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('div', {
    staticClass: "image-container",
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        _vm.handleWheel($event)
      }
    }
  }, [_c('div', {
    staticClass: "image-container",
    style: ({
      transform: ("rotate(" + _vm.rotation + "deg) scale(" + _vm.zoom + ")")
    })
  }, [(_vm.viewScannedImage) ? _c('img', {
    ref: "previewImage",
    staticClass: "preview-image",
    attrs: {
      "src": _vm.previewScannerImageUrl
    },
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        _vm.handleWheel($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isScannerImageLoading) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()])]), _vm._v(" "), _vm._v("modal\n                "), (_vm.disabledActionButtonDiv) ? _c('div', {
    staticClass: "icon-group overlay-footer",
    class: {
      'disabled': _vm.disabledActionButtonDiv
    }
  }, [_c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.loadScannedImageByScanner
    }
  }, [_c('i', {
    staticClass: "fa fa-camera camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.rotateScannedImage
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('i', {
    staticClass: "fa fa-search-minus  camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.cancelScannedImage
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(4)])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('b-card-group', {
    staticStyle: {
      "height": "80vh",
      "overflow-y": "scroll",
      "text-align": "center"
    },
    attrs: {
      "deck": ""
    }
  }, [_c('b-card', {
    attrs: {
      "header": "View Image",
      "header-tag": "header"
    }
  }, [_c('div', _vm._l((_vm.selectedPodImagesByScanner), function(data, index) {
    return _c('div', {
      staticClass: "image-container_view"
    }, [_c('img', {
      staticClass: "styled-image",
      attrs: {
        "src": data,
        "alt": "Your Image"
      },
      on: {
        "click": function($event) {
          _vm.viewScannerImage(data)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times-circle close-icon",
      on: {
        "click": function($event) {
          _vm.removeScannerCapturedImage(index)
        }
      }
    }), _c('br')])
  })), _vm._v(" "), (_vm.viewScannerImageUploadButton) ? _c('footer', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.uploadScannerCapturedBinaryImage()
      }
    }
  }, [_vm._v("Upload Image")])]) : _vm._e()])], 1)], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.uploadBrowsePodImageMdlFlag) ? _c('div', [_c('div', {
    staticClass: "custom-modal show-custom-modal"
  }, [_c('div', {
    staticClass: "custom-modal-content ",
    staticStyle: {
      "height": "83vh",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10",
    staticStyle: {
      "overflow-y": "initial"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "text": "Please wait !!",
      "color": "#FF6700",
      "active": _vm.isScannerImageLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isScannerImageLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui"
  }, [_c('div', {
    staticClass: "sticky-row",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "files",
    attrs: {
      "id": "selectPodImage",
      "name": "selectPodImage",
      "multiple": "",
      "type": "file",
      "accept": "image/*",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.BrowsePodImage
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('uploadform.BrowsePodImage')),
      expression: "errors.has('uploadform.BrowsePodImage')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Choose\n                        file\n                        to upload")])]), _vm._v(" "), _c('button', {
    staticClass: "btn-danger btn sm",
    on: {
      "click": _vm.closeBrowseUploadModal
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', {
    staticClass: "image-container",
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        _vm.handleWheel($event)
      }
    }
  }, [(_vm.previewImageUrl) ? _c('img', {
    ref: "previewImage",
    staticClass: "preview-image",
    style: ({
      transform: ("rotate(" + _vm.rotation + "deg) scale(" + _vm.zoom + ")")
    }),
    attrs: {
      "src": _vm.previewImageUrl,
      "id": "img",
      "alt": "No Image"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), (_vm.disabledActionButtonDiv) ? _c('div', {
    staticClass: "icon-group overlay-footer",
    class: {
      'disabled': _vm.disabledActionButtonDiv
    }
  }, [_c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.rotateScannedImage
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('i', {
    staticClass: "fa fa-search-minus camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(8)])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('b-card-group', {
    staticStyle: {
      "height": "80vh",
      "overflow-y": "scroll",
      "text-align": "center"
    },
    attrs: {
      "deck": ""
    }
  }, [_c('b-card', {
    attrs: {
      "header": "View Image",
      "header-tag": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, _vm._l((_vm.selectedPodImage), function(data, index) {
    return _c('div', {
      staticClass: "image-container_view"
    }, [_c('img', {
      staticClass: "styled-image",
      attrs: {
        "src": data,
        "alt": "Your Image"
      },
      on: {
        "click": function($event) {
          _vm.viewImage(data)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times-circle close-icon",
      on: {
        "click": function($event) {
          _vm.removeImage(index)
        }
      }
    }), _c('br')])
  })), _vm._v(" "), (_vm.viewBrowseImageUploadButton) ? _c('footer', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.uploadBrowsedFilesInS3()
      }
    }
  }, [_vm._v("Upload Image")])]) : _vm._e()])], 1)], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.capturePhotoMdlFlag) ? _c('div', [_c('div', {
    staticClass: "custom-modal show-custom-modal"
  }, [_c('div', {
    staticClass: "custom-modal-content ",
    staticStyle: {
      "height": "83vh",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10",
    staticStyle: {
      "overflow-y": "initial"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "text": "Please wait ..!!",
      "color": "#FF6700",
      "active": _vm.isCameraImageLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isCameraImageLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui"
  }, [_c('div', {
    staticClass: "sticky-row",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('b-input-group', {
    staticClass: "col-lg-5"
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.printerList,
      "name": "printerList",
      "id": "printerList",
      "placeholder": "Select Camera ",
      "label": "label",
      "track-by": "deviceId",
      "scroll": true
    },
    on: {
      "select": function($event) {
        _vm.onChangeCamera($event)
      }
    },
    model: {
      value: (_vm.selectedCamera),
      callback: function($$v) {
        _vm.selectedCamera = $$v
      },
      expression: "selectedCamera"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-refresh btn-success btn-sm",
    staticStyle: {
      "margin-left": "5px",
      "padding": "10px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.onClickCameraRefresh
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn-danger btn sm",
    on: {
      "click": _vm.closeTakePhotoModal
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('div', {
    staticClass: "image-container",
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        _vm.handleWheel($event)
      }
    }
  }, [(!_vm.imageData.image) ? _c('video', {
    ref: "video",
    staticClass: "camera-stream"
  }) : _c('img', {
    staticClass: "camera-stream",
    style: ({
      transform: ("rotate(" + (_vm.imageData.image_orientation) + "deg) scale(" + _vm.zoom + ")")
    }),
    attrs: {
      "src": _vm.imageData.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), (_vm.disabledActionButtonDiv) ? _c('div', {
    staticClass: "icon-group overlay-footer"
  }, [_c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.captureCameraImage
    }
  }, [_c('i', {
    staticClass: "fa fa-camera camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.rotateImage
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('i', {
    staticClass: "fa fa-search-minus camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.cancelCameraCapturedImage
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(13)])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('b-card-group', {
    staticStyle: {
      "height": "80vh",
      "overflow-y": "scroll",
      "text-align": "center"
    },
    attrs: {
      "deck": ""
    }
  }, [_c('b-card', {
    attrs: {
      "header": "View Image",
      "header-tag": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, _vm._l((_vm.selectedCameraCapturedPodImage), function(data, index) {
    return _c('div', {
      staticClass: "image-container_view"
    }, [_c('img', {
      staticClass: "styled-image",
      attrs: {
        "src": data,
        "alt": "Your Image"
      },
      on: {
        "click": function($event) {
          _vm.viewCameraImage(data)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times-circle close-icon",
      on: {
        "click": function($event) {
          _vm.removeCameraCapturedImage(index)
        }
      }
    }), _c('br')])
  })), _vm._v(" "), (_vm.viewCameraImageUploadButton) ? _c('footer', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.uploadCameraCapturedBinaryImage()
      }
    }
  }, [_vm._v("Upload Image")])]) : _vm._e()])], 1)], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.viewUploadedPodImages) ? _c('div', [_c('div', {
    staticClass: "custom-modal show-custom-modal"
  }, [_c('div', {
    staticClass: "custom-modal-content ",
    staticStyle: {
      "height": "83vh",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10",
    staticStyle: {
      "overflow-y": "initial"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "text": "Please wait image is scanning",
      "color": "#FF6700",
      "active": _vm.viewCapturedPodLoader
    },
    on: {
      "update:active": function($event) {
        _vm.viewCapturedPodLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui"
  }, [_c('div', {
    staticClass: "sticky-row",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "file-upload"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-danger btn sm",
    on: {
      "click": _vm.closeViewUploadedImageModal
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', {
    staticClass: "image-container",
    class: {
      'loading': _vm.isScannerImageLoading
    },
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        _vm.handleWheel($event)
      }
    }
  }, [(_vm.viewCapturedPodsImageSrc) ? _c('img', {
    ref: "previewImage",
    staticClass: "preview-image",
    style: ({
      transform: ("rotate(" + _vm.rotation + "deg) scale(" + _vm.zoom + ")")
    }),
    attrs: {
      "src": _vm.viewCapturedPodsImageSrc,
      "id": "img",
      "alt": "No Image"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), (_vm.disabledActionButtonDiv) ? _c('div', {
    staticClass: "icon-group overlay-footer"
  }, [_c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.rotateScannedImage
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('i', {
    staticClass: "fa fa-search-minus camera-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(16)])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('b-card-group', {
    staticStyle: {
      "height": "83vh",
      "overflow-y": "scroll",
      "text-align": "center"
    },
    attrs: {
      "deck": ""
    }
  }, [_c('b-card', {
    attrs: {
      "header": "Selected POD's",
      "header-tag": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, _vm._l((_vm.viewUploadedHubImages), function(data, index) {
    return _c('div', {
      staticClass: "image-container_view"
    }, [_c('img', {
      staticClass: "styled-image",
      attrs: {
        "src": data,
        "alt": "Your Image"
      },
      on: {
        "click": function($event) {
          _vm.viewSinglePodImage(data)
        }
      }
    })])
  }))])], 1)], 1)])])])]) : _vm._e()], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Scan Image")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Rotate")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom In")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom Out")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Cancel")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "selectPodImage"
    }
  }, [_c('a', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "font-size": "15px",
      "color": "white !important",
      "font-weight": "bold"
    },
    attrs: {
      "title": "Choose File to Upload"
    }
  }, [_vm._v("Choose\n                          File "), _c('i', {
    staticClass: "fa fa-upload",
    staticStyle: {
      "color": "#fff"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Rotate")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom In")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom Out")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Take Picture")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Rotate")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom In")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom Out")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Cancel")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Rotate")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom In")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Zoom Out")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dec5f538","hasScoped":true}!./src/modules/shared/components/podUploadComponent/podUploadComponent.component.html
// module id = 2001
// module chunks = 3